import styles from "../order-summary-form/order-summary.module.scss";
import { Skeleton } from "@material-ui/lab";
import { Text } from "components/commons";
import React from "react";

const DisplayText = ({ value, formatter, width = "300px", loading }) => {
  if (loading) return <Skeleton width={width} height="30px" />;

  if (React.isValidElement(value)) {
    return value;
  }

  return <>{formatter ? formatter(value) : value}</>;
};

export const ViewRow = ({ label, value, formatter, loading }) => (
  <div className={styles.viewRow}>
    <Text color="black">{label}</Text>
    <Text strong color="black">
      <DisplayText value={value} formatter={formatter} loading={loading} />
    </Text>
  </div>
);
